interface RankItem {
  rank: number;
  title: string;
  tag: string;
  hot: string;
  trend: 'up' | 'down' | 'same';
}

const items: RankItem[] = [
  { rank: 1, title: '暗夜追踪', tag: '悬疑剧集', hot: '986万', trend: 'up' },
  { rank: 2, title: '长安风云录 第三季', tag: '古装权谋', hot: '872万', trend: 'up' },
  { rank: 3, title: '星际迷航：新纪元', tag: '科幻电影', hot: '765万', trend: 'same' },
  { rank: 4, title: '小镇故事', tag: '文艺剧情', hot: '698万', trend: 'up' },
  { rank: 5, title: '逆光前行', tag: '热血励志', hot: '623万', trend: 'down' },
  { rank: 6, title: '深海迷踪', tag: '惊悚悬疑', hot: '587万', trend: 'up' },
];

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-accent-500 text-xs"></i>;
  if (trend === 'down') return <i className="ri-arrow-down-line text-secondary-500 text-xs"></i>;
  return <i className="ri-subtract-line text-foreground-600 text-xs"></i>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-8 md:mb-10">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热播榜单</h2>
              <p className="text-sm text-foreground-600 mt-1">实时热度排行 · 每日更新</p>
            </div>
            <div className="flex gap-1.5">
              <span className="px-3 py-1.5 rounded-full bg-primary-500/15 text-primary-500 text-xs font-medium whitespace-nowrap cursor-pointer">总榜</span>
              <span className="px-3 py-1.5 rounded-full text-xs text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">电影</span>
              <span className="px-3 py-1.5 rounded-full text-xs text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">剧集</span>
            </div>
          </div>

          <div className="bg-background-200 rounded-xl overflow-hidden">
            {items.map((item, i) => (
              <a
                key={i}
                href="#ranking"
                className={`flex items-center gap-4 px-5 py-4 cursor-pointer transition-colors hover:bg-background-300 ${
                  i < items.length - 1 ? 'border-b border-background-300/60' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-300 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-foreground-950 whitespace-nowrap">{item.title}</span>
                    <span className="text-[10px] text-foreground-600 bg-background-300 px-1.5 py-0.5 rounded whitespace-nowrap hidden sm:inline-block">{item.tag}</span>
                  </div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <TrendIcon trend={item.trend} />
                  <span className="text-sm text-foreground-600 whitespace-nowrap">{item.hot}</span>
                </div>
                <div className="shrink-0 w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-foreground-600"></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}